import { ActionTree } from "vuex";
import { IPagination, RootState } from "@/types";
import {
  IDepartment,
  IDepartmentListRequest,
  DepartmentState,
} from "@/types/department";
import CustomRequest from "../customRequest";

const actions: ActionTree<DepartmentState, RootState> = {
  async get({ commit }, id: number) {
    await CustomRequest.get<IPagination<IDepartment>>({
      uri: `/department/${id}`,
      commit,
      target: "single",
    });
  },

  async getList({ commit }, params: IDepartmentListRequest) {
    await CustomRequest.get<IPagination<IDepartment>>({
      uri: "/department",
      params,
      commit,
      target: "pagination",
    });
  },
};

export default actions;
